import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useRatePlan} from "../hooks/useRatePlan.ts";
import {BillablePeriod, BillableUnit, RatePlan} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useRatePlan();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                billableUnit: BillableUnit.USER,
                billablePeriod: BillablePeriod.MONTH,
                chargeTiers: [],
            } as RatePlan}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
